<template>
  <v-container>
    <v-row no-gutters>
      <v-col>
        <v-toolbar dense flat>
          <v-btn icon to="/">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="deleteDialog = true"
            v-if="list.userID === user.uid"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn icon @click="editDialog = true">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="shareDialog = true"
            v-if="list.userID === user.uid"
          >
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>{{ list.listName }}</v-card-title>
          <v-list dense>
            <v-list-item disabled v-if="currentItems.length === 0"
              >No items have been added to this list yet.</v-list-item
            >
            <v-list-item v-for="item in currentItems" :key="item.id">
              <v-list-item-action>
                <v-checkbox
                  v-model="item.done"
                  @change="updateList()"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.store !== ''">{{
                  item.store
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="deleteItem(item.id)" small>
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-toolbar dense flat>
          <v-text-field
            label="New Item"
            hide-details
            single-line
            v-model="newItem.name"
          ></v-text-field>
          <v-btn icon color="primary" @click="storeDialog = true"
            ><v-icon>mdi-store</v-icon></v-btn
          >
          <v-btn
            icon
            color="primary"
            :disabled="newItem.name === ''"
            @click="addItem()"
            ><v-icon>mdi-plus</v-icon></v-btn
          >
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row v-if="completedItems.length > 0">
      <v-col>
        <v-card>
          <v-card-title class="text--disabled"
            >Completed <v-spacer></v-spacer
            ><v-btn text @click="clearDone()" color="grey lighten-1"
              >Clear</v-btn
            ></v-card-title
          >
          <v-list dense>
            <v-list-item v-for="item in completedItems" :key="item.id">
              <v-list-item-action>
                <v-checkbox
                  v-model="item.done"
                  @change="updateList()"
                  color="grey lighten-1"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="text--disabled">{{
                  item.name
                }}</v-list-item-title>
                <v-list-item-subtitle
                  v-if="item.store !== ''"
                  class="text--disabled"
                  >{{ item.store }}</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  @click="deleteItem(item.id)"
                  small
                  color="grey lighten-1"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="350">
      <v-card>
        <v-card-title>Delete List?</v-card-title>
        <v-card-text>This cannot be undone.</v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn text @click="deleteDialog = false" color="primary"
            >Cancel</v-btn
          >
          <v-btn text @click="deleteList()" color="primary"
            >Delete</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="350">
      <v-card>
        <v-card-title>Edit List</v-card-title>
        <v-card-text>
          <v-text-field
            label="List Name"
            v-model="list.listName"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer
          ><v-btn text color="primary" @click="editDialog = false">Cancel</v-btn
          ><v-btn text color="primary" @click="saveList()"
            >Save</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="storeDialog" max-width="350">
      <v-card>
        <v-card-title>Set Store</v-card-title>
        <v-card-text>
          <v-text-field label="Store" v-model="newItem.store"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer
          ><v-btn text color="primary" @click="storeDialog = false"
            >Close</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="shareDialog" max-width="350">
      <v-card>
        <v-card-title>Share List</v-card-title>
        <v-card-text>
          <v-text-field
            label="Email Address"
            v-model="shareEmail"
          ></v-text-field>
          <v-list>
            <v-list-item v-for="user in list.sharedUsers" :key="user.uid"
              >{{ user.userFirst }} {{ user.userLast }}</v-list-item
            >
          </v-list>
        </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn text color="primary" @click="shareDialog = false"
            >Close</v-btn
          >
          <v-btn text color="primary" @click="shareList()">Share</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      list: {},
      deleteDialog: false,
      editDialog: false,
      shareDialog: false,
      storeDialog: false,
      newItem: {
        name: "",
        store: ""
      },
      shareEmail: ""
    };
  },
  created() {
    this.loadList();
  },
  computed: {
    ...mapState(["user"]),
    currentItems() {
      if (this.list.listItems) {
        return this.list.listItems.filter(item => !item.done);
      } else {
        return [];
      }
    },
    completedItems() {
      if (this.list.listItems) {
        return this.list.listItems.filter(item => item.done);
      } else {
        return [];
      }
    }
  },
  methods: {
    loadList() {
      const self = this;
      const docRef = this.$db.collection("lists").doc(this.$route.params.id);
      docRef.onSnapshot(doc => {
        if (doc.exists) {
          self.list = doc.data();
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      });
    },
    updateList() {
      const self = this;
      this.$db
        .collection("lists")
        .doc(this.$route.params.id)
        .set(self.list)
        .then(function() {
          console.log("List saved!");
        })
        .catch(function(error) {
          console.log("Error saving budget:", error);
        });
    },
    deleteItem(ID) {
      this.list.listItems = this.list.listItems.filter(
        itemObject => itemObject.id !== ID
      );
      this.updateList();
    },
    deleteList() {
      const self = this;
      this.$db
        .collection("lists")
        .doc(this.$route.params.id)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          self.$router.push("/");
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    },
    saveList() {
      this.updateList();
      this.editDialog = false;
    },
    addItem() {
      if (this.newItem.naem !== "") {
        this.list.listItems.push({
          name: this.newItem.name,
          id: Math.random()
            .toString(36)
            .substr(2, 9),
          store: this.newItem.store,
          done: false
        });
        this.newItem.name = "";
        this.updateList();
      }
    },
    shareList() {
      const self = this;
      const docRef = this.$db.collection("users").doc(this.shareEmail);
      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            //console.log("Document data:", doc.data());
            const userdata = doc.data();
            if ("sharedUsers" in self.list) {
              self.list.sharedUsers.push(userdata);
              self.list.sharedUIDs.push(userdata.uid);
            } else {
              self.list.sharedUsers = [];
              self.list.sharedUIDs = [];
              self.list.sharedUsers.push(userdata);
              self.list.sharedUIDs.push(userdata.uid);
            }
            alert(
              self.list.listName +
                " has been shared with " +
                userdata.userFirst +
                " " +
                userdata.userLast
            );
            self.updateList();
            self.shareDialog = false;
            self.shareEmail = "";
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
            alert("No user with that email address exists");
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    },
    clearDone() {
      this.completedItems.forEach(doneItem => {
        this.list.listItems = this.list.listItems.filter(
          item => item.id !== doneItem.id
        );
      });
      this.updateList();
    }
  }
};
</script>

<style lang="scss" scoped></style>
